import {useContext} from 'react';

import {StudentQuizContext} from '../contexts';

export const useStudentQuiz = () => {
  return useContext(StudentQuizContext);
};
